import { Formattable } from 'visuris/Data/Entities/Formattable';
import { formatDate } from 'visuris/Data/Formatters';
import * as i18n from 'CMS/core/i18n';
import * as Constants from 'visuris/Constants';

export default class NtS extends Formattable {

    public headerId: string = null;
    public sectionId: string = null;
    public organisation: string = null;
    public dateIssue: Date = null;
    public dateStart: Date = null;
    public dateEnd: Date = null;
    public state: number = null;
    public messageType: number = null;
    public title: string = null;
    public internalId: string = null;
    public versionId: string = null;
    public year: string = null;
    public number: string = null;
    public serialNumber: string = null;
    public displayOnMap: boolean = null;
    public xsdVersion: string = null;
    public versionNumber: number = null;
    public internalMessage: boolean = null;
    public xml: string = null;
    public hindranceState: number = null;
    public stateMessage: string = null;
    public messageTypeMessage: string = null;
    public hindranceStateMessage: string = null;
    public relatedFairways: string[] = null;
    public targetaudiences: string[] = null;
    public limitations: string[] = null;
    public country: string = null;
    public countryCode: string = null;
    public originator: string = null;
    public missingData: boolean = null;

    constructor() {
        super();
    }

    protected getFormatters(): any {        
        return {
            "number": () => { return this.state === 15 ? this.internalId : this.number },
            "countryNumberCombo": () => {return this.number != null && this.countryCode != null ? this.countryCode.toUpperCase() + '/' + this.number : ""  },
            "internalMessage": () => { return this.internalMessage ? i18n.getMessage("general.yes") : i18n.getMessage("general.no"); },
            "dateIssue": () => { return formatDate(this.dateIssue,"dd/MM/yyyy"); },
            "dateStart": () => { return formatDate(this.dateStart, "dd/MM/yyyy"); },
            "dateEnd": () => { return this.dateEnd != null && this.dateEnd.getTime() !== 8640000000000000 && this.dateEnd.getFullYear() !== 9999 ? formatDate(this.dateEnd, "dd/MM/yyyy") : ""; },
            "path": () => { return this.state === 80 ? "Public" : "Private"; },
            "compactTitle": () => {
                if (this.title.length > Constants.CompactTextLength.NTS_TITLE) {
                    var title = this.title.substring(0, Constants.CompactTextLength.NTS_TITLE - 1).trim();
                    title += "...";
                    return title;
                } else {
                    return this.title;
                }
            }
        };
    }
   
}